import React, {Component} from 'react';
import {
    Platform,
    FlatList,
} from "react-native"

export default class HMFlatList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            // value: 'احمد'
        }
        this.flatListRef = React.createRef();

    }


    componentWillReceiveProps(props) {


    }


    // in FlatList, add ref={ref => this._flatlistRef = ref}
    getScrollableNode = () => this.flatListRef.current.getScrollableNode();

    _invertScrolling = (invert) => {
        this._scrollNode = this.getScrollableNode();
        if (invert) {
            this._scrollNode.addEventListener('wheel', this._invertedWheelEvent);
        } else {
            this._scrollNode.removeEventListener('wheel', this._invertedWheelEvent);
        }
    };
    _invertedWheelEvent = (e) => {

        if (this.props.horizontal) this._scrollNode.scrollLeft += (e.wheelDeltaX || -e.deltaX);
        else this._scrollNode.scrollTop += (e.wheelDeltaY || -e.deltaY);
        e.preventDefault();
    };

    componentDidMount() {
        if (Platform.OS === "web" && this.props.inverted && !this.props.horizontal)
            this._invertScrolling(true);
    }

    componentWillUnmount() {
        if (Platform.OS === "web" && this.props.inverted && !this.props.horizontal)
            this._invertScrolling(false);
    }


    render() {
        //  let checkLogin = (store.getState().reducerSplashSatiaScreen.TypeLogin == 2)
        let {text, styleRoot, style, type, cammas, lang, linkStyle, linkText, onPressLink, HyperlinkCheck, numberOfLines} = this.props;


        return (

            <FlatList
                {...this.props}
                ref={mapInstance => {
                    this.flatListRef.current = mapInstance
                }}

            />

        );
    }


}
